// src/web/client/src/components/DemoModeBanner.jsx
import React from 'react';
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from 'lucide-react';

export default function DemoModeBanner() {
  const isDemo = localStorage.getItem('isDemo') === 'true' || 
                 localStorage.getItem('shop_domain') === 'demo-shop.myshopify.com';
  
  if (!isDemo) return null;

  return (
    <Alert className="mb-4 border-yellow-200 bg-yellow-50">
      <AlertTriangle className="h-4 w-4 text-yellow-600" />
      <AlertDescription className="flex items-center justify-center">
        <span className="text-yellow-800">
          <strong>Demo Mode:</strong> You're viewing sample data. Install the app from the Shopify App Store to connect your store.
        </span>
      </AlertDescription>
    </Alert>
  );
}